import { render } from "./InputFiles.vue?vue&type=template&id=5bfd154a&scoped=true"
import script from "./InputFiles.vue?vue&type=script&lang=js"
export * from "./InputFiles.vue?vue&type=script&lang=js"

import "./InputFiles.vue?vue&type=style&index=0&id=5bfd154a&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfd154a"]])

export default __exports__